module.exports = __webpack_public_path__ + "static/media/xmg_3_filter.daa0f7c0.png";